import { useMutation } from 'react-query';
import { apiService } from '../../../../../utils/api';
import { DropdownMenuItem } from '@/components/ui/Dropdown';
import { toast } from 'sonner';
import { useSelector } from 'react-redux';

const CreateTemplateFromCurrentItem = ({ id }: { id: string }) => {
  const { current_company } = useSelector((state: any) => state.auth);

  const createTemplate = useMutation({
    mutationFn: () => {
      return apiService.post(`/api/v1/instance-type/${id}/to-template/`, {
        company: current_company,
      });
    },
    onSuccess: () => {
      toast.success('Šablona byla úspěšně vytvořena');
    },
    onError: (err) => {
      console.error(err);
    },
  });

  return (
    <DropdownMenuItem
      data-testid="typemark-create-template-from-item"
      onClick={() => createTemplate.mutate()}
    >
      Vytvořit šablonu z aktuálního prvku
    </DropdownMenuItem>
  );
};

export default CreateTemplateFromCurrentItem;
